<template>
  <span class="c--loyalty-program_badge">
    <img :src="imageUrl" width="44" height="44" alt="badge" loading="lazy" />
  </span>
</template>

<script>
  export default {
    props: {
      imageUrl: {
        type: String,
        required: true,
      },
    },
  }
</script>
